<template></template>

<script>
import { db, analytics } from "@/config/firebaseInit";

export default {
  name: "initializer",
  components: {},
  data() {
    return {
      kiosks: null
    };
  },
  firestore() {
    return {
      kiosks: db.collection("kiosk")
    };
  },
  mounted() {},
  created() {
    localStorage.clear();
    this.initiateKiosk();
  },
  updated() {},
  methods: {
    async initiateKiosk() {
      let kiosk_loaded = await db
        .collection("client")
        .doc(this.$route.params.client_id)
        .collection("kiosk")
        .doc(this.$route.params.id)
        .get()
        .then(snap => {
          if (snap.exists) {
            let kiosk_data = snap.data();
            kiosk_data.id = snap.id;
            this.$store.commit("setIsMobile", true);
            this.$store.commit("setKiosk", kiosk_data);
            return true;
          } else {
            this.$router.push({ path: "/" });
            return false;
          }
        });
      if (kiosk_loaded) {
        await db
          .collection("client")
          .doc(this.$route.params.client_id)
          .get()
          .then(snap => {
            if (snap.exists) {
              let client_data = snap.data();
              client_data.id = snap.id;
              analytics.logEvent("mobile_journeys", {
                name: "mobile",
                kiosk: this.$store.state.kiosk.id,
                created_at: Date.now(),
                client_id: client_data.id
              });
              this.$router.push({ path: "/" });
              this.$store.commit("displayAd");
              this.$store.commit("setClient", client_data);
              return true;
            } else {
              this.$router.push({ path: "/" });
              return false;
            }
          });
      }
    }
  }
};
</script>

<style lang='scss'>
.kiosks {
  padding: 100px;
  max-width: 1200px;
  margin: auto;
  h1 {
    width: 100%;
    text-align: center;
    font-size: 50px;
    margin-top: 0;
  }
  .kiosk {
    background-color: white;
    border: 2px solid #eaeaea;
    padding: 20px;
    margin-bottom: 20px;
    p {
      margin: 0;
      font-size: 30px;
      &.name {
        font-size: 40px;
        font-weight: bold;
      }
    }
  }
}
</style>
